// src/api/userFinance.js
import http from "./http";

export const fetchMyTransactions = () => {
  return http.get("/stores/my-transactions/");
};
